import {
    Card, Checkbox, FormControlLabel, Grid
} from "@mui/material";
import { generateUnitCountPDFApi, getReportUnitCountApi } from 'api/report'; // API fonksiyonlarını import et
import ReportFilterCard from "app/components/Card/report/ReportFilterCard";
import ReportUnitCountTable from "app/components/Table/reports/ReportUnitCountTable";
import React, { useState } from "react";

const ReportUnitCountPage = () => {
    const [data, setData] = useState([]);
    const [lastFilter, setLastFilter] = useState(null);
    const [showWithDates, setShowWithDates] = useState(false);

    const setFilterData = (data) => {
        setData(data);
    };

    const handleResultListUnitCount = async (filters) => {
        try {
            const res = await getReportUnitCountApi(filters);
            const responseData = res.data;
            setFilterData(responseData.data);
            setLastFilter(filters);
        } catch (err) {
            console.error(err);
        }
    };

    const generateUnitCountPDF = async () => {
        if (!lastFilter) return;
        try {
            await generateUnitCountPDFApi(lastFilter);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <React.Fragment>
            <Grid container sx={{ marginBottom: 4 }}>
                <Grid item xs={12} md={12}>
                    <ReportFilterCard
                        title="Kurul/Kol/Komisyonların Toplantı Sayısı"
                        setFilterData={setFilterData}
                        handleResultList={handleResultListUnitCount}
                        generatePDFApi={generateUnitCountPDF}
                        showUnitFilter={false}
                        additionalFilterContent={
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showWithDates}
                                        onChange={(e) => setShowWithDates(e.target.checked)}
                                        size="small"
                                    />
                                }
                                label="Tarihleriyle göster"
                            />
                        }
                        additionalFilterValues={{ showWithDates }}
                    />
                </Grid>
            </Grid>

            {data.length > 0 && (
                <Card sx={{ padding: 2 }}>
                    <ReportUnitCountTable data={data} showWithDates={lastFilter?.showWithDates} />
                </Card>
            )}
        </React.Fragment>
    );
};

export default ReportUnitCountPage;

